
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-3e32201d\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":false}!sass-resources-loader?{\"resources\":\"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss\"}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./JobSummary.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./JobSummary.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3e32201d\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./JobSummary.vue"),
  /* scopeId */
  "data-v-3e32201d",
  /* cssModules */
  null
)
Component.options.__file = "/builds/trek10-siemens/portal-frontend/src/components/JobSummary.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] JobSummary.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3e32201d", Component.options)
  } else {
    hotAPI.reload("data-v-3e32201d", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/JobSummary.vue
// module id = 197
// module chunks = 1